

import { Channel, ChannelGroupingResult, ChannelType, MaybeChannelGroupingResult } from "./channelgrouping";
import {ParsedUrlParams} from "./urlparams";
import { Utms } from "./utms";


export default class DisplayChannel {

    public static is(params: ParsedUrlParams) : MaybeChannelGroupingResult {

        // first, check for a display network click id from google
        if (typeof(params['dclid']) !== 'undefined') {
            return new ChannelGroupingResult(Channel.Display, ChannelType.Other);
        }

        // second, check for a utm-medium of display
        const utms = new Utms(params);
        const medium = utms.getMedium();
        if (medium) {
            if (medium.toLowerCase().trim() === 'display') {
                return new ChannelGroupingResult(Channel.Display, ChannelType.Other);
            }
        }

        // lastly, check if the source was simplifi - which classifies as display
        const source = utms.getSource();
        if (source) {
            if (source.toLowerCase().trim() === 'simplifi_geofencing') {
                return new ChannelGroupingResult(Channel.Display, ChannelType.Other);
            }
        }
        return null;
    }

}